import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'wouter';
import { useQueryClient } from '@tanstack/react-query';
import { api } from '../api.ts';
import { track } from '../analytics.ts';

export function DemoLanding() {
  const { t } = useTranslation();
  const [, navigate] = useLocation();
  const qc = useQueryClient();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const points = t('demo.landing.points', { returnObjects: true }) as string[];

  async function enter() {
    setBusy(true);
    setError(false);
    try {
      const res = await api<{ reused: boolean }>('/api/demo', { method: 'POST' });
      if (!res.reused) track('demo_start');
      await qc.invalidateQueries({ queryKey: ['me'] });
      const devices = await api<{ id: string }[]>('/api/devices');
      navigate(devices[0] ? `/devices/${devices[0].id}` : '/');
    } catch {
      setError(true);
      setBusy(false);
    }
  }

  return (
    <section className="landing stack">
      <p className="eyebrow">{t('demo.landing.eyebrow')}</p>
      <h1>{t('demo.landing.title')}</h1>
      <p className="muted lead">{t('demo.landing.lead')}</p>
      <ul className="points">{points.map((p) => <li key={p}>{p}</li>)}</ul>
      <div className="row">
        <button className="btn" onClick={enter} disabled={busy}>{busy ? t('demo.landing.entering') : t('demo.landing.enter')} →</button>
        <Link href="/login" className="muted">{t('demo.landing.haveAccount')}</Link>
      </div>
      {error && <p className="error" role="alert">{t('demo.landing.error')}</p>}
    </section>
  );
}
